module.exports = __webpack_public_path__ + "img/C3.c4396597.jpg";